/* 🤖 this file was generated by svg-to-ts */
export const emperorIconClock: {
  name: 'clock';
  data: string;
} = {
  name: 'clock',
  data: `<svg viewBox="0 0 24 24" id="svg3969" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z" id="path3965"/><path d="m 12.042,2 c -5.523,0 -10,4.477 -10,10 0,5.523 4.477,10 10,10 5.52,0 10,-4.477 10,-10 0,-5.523 -4.48,-10 -10,-10 z m 0.442006,10.216968 4.539638,2.703755 -0.801113,1.201669 -5.207232,-3.137691 V 7.009736 h 1.468707 z" id="path3967"/></svg>`
};
